import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56a7f4ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_button, {
    style: {
      "margin-left": "5vw",
      "margin-top": "1vw"
    },
    type: "primary",
    icon: "ArrowLeft",
    circle: "",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back(-1))
  }), _createElementVNode("iframe", {
    class: "iframe",
    src: $setup.data.url
  }, null, 8, _hoisted_1)], 64);
}